import { useState } from 'react';
import { createPortal } from 'react-dom';
import CloseIcon from '../assets/icons/close.svg?react';
import { useMobileSidebar } from '../contexts/MobileSidebarContext';
import { useResponsive } from '../hooks/useResponsive';
import { AccountButton } from './AccountButton';
import { IconButton } from './IconButton';
import { Navigation } from './Navigation';

export function SidebarMobile() {
  const { isOpen, close, toggle } = useMobileSidebar();
  const { prefersMobileLayout } = useResponsive();
  const [shouldRender, setShouldRender] = useState(false);

  if (!prefersMobileLayout) {
    return null;
  }

  // Keep component mounted if opening or if we need to animate out
  const show = isOpen || shouldRender;

  const handleAnimationEnd = () => {
    if (!isOpen) {
      setShouldRender(false);
    }
  };

  // Show immediately when opening
  if (isOpen && !shouldRender) {
    setShouldRender(true);
  }

  if (!show) return null;

  const state = isOpen ? 'open' : 'closed';

  return createPortal(
    <>
      {/* Overlay */}
      <div
        data-mobile-sidebar-overlay
        data-state={state}
        className='fixed inset-0 z-40 bg-black/50'
        onClick={close}
        onAnimationEnd={handleAnimationEnd}
      />

      {/* Sidebar */}
      <aside
        data-mobile-sidebar
        data-state={state}
        className='bg-surface border-border-primary fixed top-0 left-0 z-50 flex
          h-full w-70 flex-col justify-between border-r shadow-xl'
      >
        <div
          className='bg-brand-primary flex h-(--spacing-header-height-mobile)
            items-center justify-between px-4'
        >
          <img src='/logo-mobile-header.svg' alt='Tomra Logo' className='h-4' />
          <IconButton
            aria-label='Toggle menu'
            icon={
              <CloseIcon
                height={20}
                width={20}
                className='fill-white [&_path]:fill-white'
              />
            }
            onClick={toggle}
            className='hover:bg-transparent'
          />
        </div>
        <div className='flex flex-1 flex-col justify-between'>
          <Navigation />
          <AccountButton />
        </div>
      </aside>
    </>,
    document.body
  );
}
